import { createReorderInstances, ReorderUI } from './reorderUI';

class Reorder {
    constructor(private ui: ReorderUI) {
    }
}

export function initReorder() {
    return createReorderInstances().map((value, index) => {
        return new Reorder(value);
    })
}